/*
 * @Author: freedeng
 * @Date: 2019-07-19 10:02:32
 * @Last Modified by: freedeng
 * @Last Modified time: 2019-08-22 20:11:36
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MutexLock, LockStrategy, } from './MutexLock';
import Log from './Log';
import { Result } from '@tencent/tdoc-database';
var MultiTabLock = /** @class */ (function (_super) {
    __extends(MultiTabLock, _super);
    function MultiTabLock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiTabLock.prototype.getDefaultConfig = function () {
        return {
            strategy: LockStrategy.ONCE,
            period: 5 * 60 * 1000,
            autoRenewal: true,
        };
    };
    MultiTabLock.prototype.getXKey = function (key) {
        return MultiTabLock.PREFIX_LOCK_X + "_" + key;
    };
    MultiTabLock.prototype.getYKey = function (key) {
        return MultiTabLock.PREFIX_LOCK_Y + "_" + key;
    };
    MultiTabLock.prototype.tryToLockKey = function (key, optional, onSuccess, onError) {
        var _this = this;
        var lockX = this.getXKey(key);
        var lockY = this.getYKey(key);
        if (MultiTabLock.DEBUG) {
            Log.log("tryToLockKey(). strategy=" + this.strategy + " lockX=" + lockX + " lockY=" + lockY);
        }
        // 1、写入X锁
        localStorage.setItem(lockX, this.tabId);
        // 2. 查看Y锁
        var valueY = localStorage.getItem(lockY);
        if (MultiTabLock.DEBUG) {
            Log.log("tryToLockKey(). strategy=" + this.strategy + " lockX=" + lockX + " lockY=" + lockY + " valueY=" + valueY);
        }
        if (valueY) {
            var lockItemY_1 = JSON.parse(valueY);
            // Y锁被其他tab写了值，那就看看有效期有没有到  如果到了，那就当做没有被占有 如果没到，那就说明Y锁被其他tab占有着。本次竞争锁失败
            if (lockItemY_1.expire > Date.now()) {
                if (MultiTabLock.DEBUG) {
                    Log.log("tryToLockKey(). \u88AB\u5176\u4ED6tab\u62FF\u5230\u4E86Y\u9501 strategy=" + this.strategy + " lockX=" + lockX + " lockY=" + lockY + " valueY=" + valueY);
                }
                // 还没到有效期
                Log.log('有其他tab已经拿到了Y锁');
                if (this.strategy === LockStrategy.ONCE) {
                    onError(lockItemY_1);
                }
                else {
                    setTimeout(function () { return _this.tryToLockKey(key, optional, onSuccess, onError); });
                }
                return;
            }
        }
        // 3. 占有Y锁
        var lockItemY = { tabId: this.tabId, expire: Date.now() + this.period, optional: optional };
        localStorage.setItem(lockY, JSON.stringify(lockItemY));
        if (MultiTabLock.DEBUG) {
            Log.log("tryToLockKey(). \u5199\u5165Y\u9501. strategy=" + this.strategy + " lockX=" + lockX + " lockY=" + lockY + " valueY=" + valueY + " lockItemY=" + lockItemY);
        }
        // 4. 查看X锁
        var valueX = localStorage.getItem(lockX);
        if (MultiTabLock.DEBUG) {
            Log.log("tryToLockKey(). \u67E5\u770BX\u9501. strategy=" + this.strategy + " lockX=" + lockX + " lockY=" + lockY + " valueY=" + valueY + " valueX=" + valueX);
        }
        if (valueX !== this.tabId) {
            // 有其他tab竞争该锁
            // 要隔一会再来看看 不能直接看
            setTimeout(function () {
                var isSuccess = false;
                valueY = localStorage.getItem(lockY);
                var lockItemY = JSON.parse(valueY || '{}');
                if (MultiTabLock.DEBUG) {
                    Log.log("tryToLockKey(). \u518D\u6B21\u67E5\u770BY\u9501. strategy=" + _this.strategy + " lockX=" + lockX + " lockY=" + lockY + " valueY=" + valueY + " valueX=" + valueX);
                }
                if (valueY) {
                    if (lockItemY.tabId === _this.tabId && lockItemY.expire > Date.now()) {
                        // 说明Y锁被我们拿到了
                        isSuccess = true;
                    }
                }
                if (isSuccess) {
                    if (MultiTabLock.DEBUG) {
                        Log.log("tryToLockKey(). \u7ADE\u4E89\u9501\u6210\u529F. strategy=" + _this.strategy + " lockX=" + lockX + " lockY=" + lockY);
                    }
                    onSuccess(lockItemY);
                }
                else {
                    // 被其他人占有了Y锁 本次竞争锁失败
                    if (_this.strategy === LockStrategy.ONCE) {
                        if (MultiTabLock.DEBUG) {
                            Log.log("tryToLockKey(). \u7ADE\u4E89\u9501\u5931\u8D25. strategy=" + _this.strategy + " lockX=" + lockX + " lockY=" + lockY);
                        }
                        onError(lockItemY);
                    }
                    else {
                        if (MultiTabLock.DEBUG) {
                            Log.log("tryToLockKey(). \u7ADE\u4E89\u9501\u5931\u8D25\uFF0C\u91CD\u65B0\u7ADE\u4E89. strategy=" + _this.strategy + " lockX=" + lockX + " lockY=" + lockY);
                        }
                        setTimeout(function () { return _this.tryToLockKey(key, optional, onSuccess, onError); });
                    }
                }
            });
        }
        else {
            if (MultiTabLock.DEBUG) {
                Log.log("tryToLockKey(). \u7ADE\u4E89\u9501\u6210\u529F. strategy=" + this.strategy + " lockX=" + lockX + " lockY=" + lockY);
            }
            // 没有人占有锁，拿到锁了
            onSuccess(lockItemY);
        }
    };
    MultiTabLock.prototype.lock = function (key, optional) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                            _this.tryToLockKey(key, optional, resolve, reject);
                        }).then(function (item) {
                            if (_this.autoRenewal) {
                                _this.renewal(key, _this.period);
                            }
                            return { isSuccess: true, data: item };
                        }, function (item) {
                            var xKey = _this.getXKey(key);
                            // 如果x锁还是自己页面种的话  那就一起删掉吧
                            if (localStorage.getItem(xKey) === _this.tabId) {
                                localStorage.removeItem(xKey);
                            }
                            return { isSuccess: false, data: item };
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * 检测锁被哪个tab拿到了
     * @param key
     */
    MultiTabLock.prototype.detectKey = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var lockY, result, valueY, lockItemY;
            return __generator(this, function (_a) {
                lockY = this.getYKey(key);
                result = new Result(undefined, undefined);
                valueY = localStorage.getItem(lockY);
                if (valueY) {
                    lockItemY = JSON.parse(valueY);
                    // 超过有效期 锁失效 所以需要有效期大于当前时间
                    if (lockItemY.expire > Date.now()) {
                        result.data = lockItemY;
                    }
                }
                return [2 /*return*/, result];
            });
        });
    };
    /**
     * 释放锁
     * @param key
     */
    MultiTabLock.prototype.release = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var xKey, yKey, oldItemValue, oldItem, timeOutId;
            return __generator(this, function (_a) {
                xKey = this.getXKey(key);
                yKey = this.getYKey(key);
                oldItemValue = localStorage.getItem(yKey);
                if (oldItemValue) {
                    oldItem = JSON.parse(oldItemValue);
                    if (oldItem.tabId === this.tabId) {
                        if (MultiTabLock.DEBUG) {
                            Log.log("releaseKey(). \u91CA\u653E\u9501. strategy=" + this.strategy + " key=" + key);
                        }
                        localStorage.removeItem(yKey);
                        // 如果x锁还是自己页面种的话  那就一起删掉吧
                        if (localStorage.getItem(xKey) === this.tabId) {
                            localStorage.removeItem(xKey);
                        }
                    }
                }
                timeOutId = MultiTabLock.renewalHanlder.get(key);
                if (timeOutId) {
                    clearTimeout(timeOutId);
                    MultiTabLock.renewalHanlder.delete(key);
                }
                return [2 /*return*/, true];
            });
        });
    };
    /**
     * 续期
     * @param key
     */
    MultiTabLock.prototype.renewal = function (key, period) {
        var _this = this;
        // 取消上一个的自动续期
        var oldTimeOutId = MultiTabLock.renewalHanlder.get(key);
        if (oldTimeOutId) {
            clearTimeout(oldTimeOutId);
        }
        var timeOutId = setTimeout(function () {
            if (MultiTabLock.DEBUG) {
                Log.log("renewal(). \u81EA\u52A8\u7EED\u671F\u9501. strategy=" + _this.strategy + " key=" + key + " period=" + period);
            }
            var yKey = _this.getYKey(key);
            var oldItemValue = localStorage.getItem(yKey);
            if (!oldItemValue) {
                // 没有y锁 那就不续期了
                Log.error('Y锁没有读到值');
                return;
            }
            var oldItem = JSON.parse(oldItemValue);
            if (oldItem.tabId !== _this.tabId) {
                Log.error('自动续期失败，Y锁已经被其他地方占有了。', oldItem);
                return;
            }
            var newItemValue = __assign(__assign({}, oldItem), { expire: Date.now() + _this.period });
            localStorage.setItem(_this.getYKey(key), JSON.stringify(newItemValue));
            // 启动下一个延期续期指令
            _this.renewal(key, period);
        }, period * 0.85);
        MultiTabLock.renewalHanlder.set(key, timeOutId);
        return timeOutId;
    };
    MultiTabLock.PREFIX_LOCK_X = 'prefix_lock_x';
    MultiTabLock.PREFIX_LOCK_Y = 'prefix_lock_y';
    return MultiTabLock;
}(MutexLock));
export default MultiTabLock;
export { MultiTabLock };
//# sourceMappingURL=MultiTabLock.js.map